/**
 * Created by Administrador on 22/12/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('kardexService', kardexService);

    kardexService.$inject = ['$http', 'CONFIG', 'messageService'];


    function kardexService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CONFIG_GENERAL + '/' + CONFIG.API + '/kardexes';
        var service = {
            saveHave: saveHave
        };

        return service;

        function saveHave(kardex){
            return $http.post(urlBase, kardex)
                .then(function(response){
                    messageService.register('customerCorporates');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('customerCorporates');
                });
        }
    }
})();
